(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cocktails-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const toggles = document.querySelectorAll('[data-cocktails-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const card = btn.closest('[data-cocktails-card]');
        if (card) {
          card.classList.toggle('is-open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* Always keep header visible — just track scroll position */
      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'header--hidden');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-sticky');
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      /* No-op: header is always visible */
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'header--hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'header--hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Handle transparent header scroll effect
  (function () {
    let transparentHeader = null;
    let scrollTimeout = null;
    let ticking = false;

    function handleScroll() {
      if (!transparentHeader) {
        transparentHeader = document.querySelector('.header-wrapper.index-transparent');
        if (!transparentHeader) return;
      }

      // Use pageYOffset for better compatibility
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      const sectionHeader = document.querySelector('.section-header');
      if (scrollTop > 50) {
        transparentHeader.classList.add('scrolled');
        if (sectionHeader) sectionHeader.classList.add('scrolled-past-header');
      } else {
        transparentHeader.classList.remove('scrolled');
        if (sectionHeader) sectionHeader.classList.remove('scrolled-past-header');
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    }

    function initScrollHandler() {
      transparentHeader = document.querySelector('.header-wrapper.index-transparent');
      if (!transparentHeader) return;

      handleScroll(); // Check initial state
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollHandler);
    } else {
      initScrollHandler();
    }

    // Re-check scroll state periodically (useful for editor updates)
    function debouncedScrollCheck() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        if (!ticking) {
          window.requestAnimationFrame(handleScroll);
          ticking = true;
        }
      }, 100);
    }

    // Re-check on window load (editor might trigger this)
    window.addEventListener('load', debouncedScrollCheck);

    // Re-check on resize (editor might change layout)
    window.addEventListener('resize', debouncedScrollCheck, { passive: true });

    // Re-check when CSS custom properties might change (editor updates)
    if (window.MutationObserver) {
      const observer = new MutationObserver(function (mutations) {
        let shouldCheck = false;
        mutations.forEach(function (mutation) {
          // Check if attributes changed (like class or style)
          if (mutation.type === 'attributes') {
            shouldCheck = true;
          }
          // Check if child nodes changed (header might be re-rendered)
          if (mutation.type === 'childList' && mutation.target.closest && mutation.target.closest('.header-wrapper')) {
            shouldCheck = true;
          }
        });
        if (shouldCheck) {
          debouncedScrollCheck();
        }
      });

      // Observe document for changes
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        subtree: true,
      });

      // Also observe the header wrapper specifically
      const headerObserver = new MutationObserver(debouncedScrollCheck);
      document.addEventListener('DOMContentLoaded', function () {
        const header = document.querySelector('.header-wrapper.index-transparent');
        if (header) {
          headerObserver.observe(header, {
            attributes: true,
            attributeFilter: ['class', 'style'],
            childList: true,
            subtree: true,
          });
        }
      });
    }

    // Re-initialize if header is re-added to DOM (editor might replace it)
    if (window.MutationObserver) {
      const headerCheckObserver = new MutationObserver(function () {
        if (!transparentHeader || !document.contains(transparentHeader)) {
          initScrollHandler();
        }
      });
      headerCheckObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"]) return;
  try {
    
  (function () {
    var carousels = document.querySelectorAll('[data-pg-carousel]');

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-pg-track]');
      if (!track) return;

      var offset = 0;
      var autoSpeed = 0.1;          /* px per frame — gentle drift */
      var scrollMultiplier = 1.5;   /* wheel sensitivity */
      var userTimeout = null;
      var isUserScrolling = false;
      var rafId = null;

      /* Duplicate images for seamless looping */
      var originalHTML = track.innerHTML;
      track.innerHTML = originalHTML + originalHTML + originalHTML;

      /* Total width of one set of images */
      function getSetWidth() {
        var children = track.children;
        var count = children.length / 3;
        var w = 0;
        for (var i = 0; i < count; i++) {
          w += children[i].offsetWidth;
        }
        return w;
      }

      /* Clamp offset so we loop seamlessly */
      function wrapOffset() {
        var setW = getSetWidth();
        if (setW <= 0) return;
        /* Keep offset in the middle copy so we can scroll both ways */
        if (offset >= setW * 2) offset -= setW;
        if (offset < setW) offset += setW;
      }

      /* Start in the middle copy */
      function init() {
        var setW = getSetWidth();
        offset = setW;
        track.style.transform = 'translateX(' + (-offset) + 'px)';
      }

      /* Animation loop */
      function tick() {
        if (Math.abs(momentum) > 0.1) {
          offset += momentum;
          momentum *= 0.93; /* friction */
        } else {
          momentum = 0;
          if (!isUserScrolling) {
            offset += autoSpeed;
          }
        }
        wrapOffset();
        track.style.transform = 'translateX(' + (-offset) + 'px)';
        rafId = requestAnimationFrame(tick);
      }

      /* Pause auto-scroll briefly after user interaction, then resume */
      function pauseAuto() {
        isUserScrolling = true;
        clearTimeout(userTimeout);
        userTimeout = setTimeout(function () {
          isUserScrolling = false;
        }, 1000);
      }

      /* Wheel → only horizontal (deltaX) moves gallery, vertical scrolls page */
      carousel.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          e.preventDefault();
          offset += e.deltaX * scrollMultiplier;
          pauseAuto();
        }
        /* vertical scroll (deltaY) passes through to the page */
      }, { passive: false });

      /* Touch drag — only horizontal swipes move gallery */
      var touchStartX = 0;
      var touchStartY = 0;
      var touchLastX = 0;
      var touchLastTime = 0;
      var touchLocked = null; /* 'x' or 'y' once direction is determined */
      var velocity = 0;        /* px/frame, smoothed */
      var momentum = 0;        /* inertia applied per frame after touchend */

      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchLastX = touchStartX;
        touchLastTime = performance.now();
        touchLocked = null;
        velocity = 0;
        momentum = 0;
      }, { passive: true });

      carousel.addEventListener('touchmove', function (e) {
        var x = e.touches[0].clientX;
        var y = e.touches[0].clientY;
        var now = performance.now();

        /* Lock direction on first significant move */
        if (!touchLocked) {
          var dx = Math.abs(x - touchStartX);
          var dy = Math.abs(y - touchStartY);
          if (dx > 5 || dy > 5) {
            touchLocked = dx > dy ? 'x' : 'y';
          }
        }

        if (touchLocked === 'x') {
          var diff = touchLastX - x;
          var dt = Math.max(1, now - touchLastTime);
          /* Smooth velocity: blend new sample with previous (EMA) */
          var instV = (diff / dt) * 16;  /* normalize to ~16ms frame */
          velocity = velocity * 0.7 + instV * 0.3;
          offset += diff;
          pauseAuto();
        }
        /* touchLocked === 'y' → do nothing, let page scroll */

        touchLastX = x;
        touchLastTime = now;
      }, { passive: true });

      carousel.addEventListener('touchend', function () {
        if (touchLocked === 'x') {
          momentum = velocity;
          pauseAuto();
        }
      }, { passive: true });

      /* Init once images have loaded to get proper widths */
      var images = track.querySelectorAll('img');
      var loaded = 0;
      var totalImages = images.length;

      function onReady() {
        init();
        tick();
      }

      if (totalImages === 0) {
        onReady();
      } else {
        images.forEach(function (img) {
          if (img.complete) {
            loaded++;
            if (loaded >= totalImages) onReady();
          } else {
            img.addEventListener('load', function () {
              loaded++;
              if (loaded >= totalImages) onReady();
            });
            img.addEventListener('error', function () {
              loaded++;
              if (loaded >= totalImages) onReady();
            });
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
  /* Gallery scroll progress */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-gallery-track]');
      var bar = gallery.querySelector('[data-gallery-progress]');
      if (!track || !bar) return;

      function updateProgress() {
        var scrollLeft = track.scrollLeft;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var pct = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
        bar.style.width = pct + '%';
      }

      track.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
